import { FrontOfficeAuthorizations } from 'shell/authorizations/front-office';
import { BodyLotsManagementVM } from 'front-office/view-models/lots-management/list';
import { HeadCell } from 'shell/components/shared/table/types';

export const authsObj = Object.freeze({
  read: [FrontOfficeAuthorizations.RicercaLotti],
  //create: [FrontOfficeAuthorizations.ModificaLotti],
  edit: [FrontOfficeAuthorizations.ModificaLotti],
});

export const headCells: HeadCell<BodyLotsManagementVM, keyof BodyLotsManagementVM>[] = [
  {
    id: 'service',
    label: 'Servizio',
  },
  {
    id: 'operator',
    label: 'Operatore',
  },
  {
    id: 'dateTimeAssignment',
    label: 'Data ora assegnazione',
  },
  {
    id: 'startLots',
    label: 'Inzio lotto',
  },
  {
    id: 'endLots',
    label: 'Fine lotto',
  },
  {
    id: 'cardsLots',
    label: 'Carte rilasciate',
  },
  {
    id: 'actions',
    label: '',
  },
];
